import { connect } from 'react-redux';
import { TagsComponent } from './tags.component';

const mapStateToProps = ({ lang }) => ({
  lang: lang.TAGS,
});

export const Tags = connect(mapStateToProps)(TagsComponent);
